import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const newsdata = [
  { name: 'The Harvard Crimson', href: 'https://www.thecrimson.com/sponsored/article/top-50-stem-programs-for-high-school-students/', image: 'https://s3.amazonaws.com/thumbnails.thecrimson.com/photos/2022/09/02/054426_1357404.png.1971x2000_q95_crop-smart_upscale.png', description: 'Top 50 STEM Programs for High School Students' },
  { name: 'Washington Times', href: 'https://www.washingtontimes.com/news/2025/feb/1/emma-tukhi-16-of-virginia-to-publish-research-pape/', image: "https://tiffany.house.gov/sites/evo-subsites/tiffany.house.gov/files/evo-media-image/untitled-design_1.png", description: 'Virginia teen to publish medical research paper, helps promote contest to urge peers to do likewise' },
  { name: 'Forbes', href: 'https://forbes.com.br/forbes-mulher/2025/02/menina-mulher-na-ciencia-millena-xavier-brasileira-17-anos-prep-olimpiadas/', image: "https://static.vecteezy.com/system/resources/previews/027/127/545/original/forbes-logo-forbes-icon-transparent-free-png.png", description: '17-year-old Brazilian promotes Student Olympics' },
  { name: 'US Insider', href: 'https://usinsider.com/new-online-stem-competition-international-research-olympiad/', image: "https://images.squarespace-cdn.com/content/v1/5bbbd9bf7a1fbd1cd63702f4/1698858127401-ANETK6VVUIF24QGYYVFE/US+Insider.png", description: 'New Online STEM Competition: International Research Olympiad' },
  { name: 'India Times', href: 'https://www.indiatimes.com/news/education/interested-in-research-international-research-olympiad-inspires-student-research-excellence-627891.html', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSI7Uwx7SmzkTapkxC7ipgV-2djxR5YRwqXpQ&s", description: 'Interested In Research? International Research Olympiad Inspires Student Research Excellence' },
  { name: 'Town Times', href: 'https://www.ttownmedia.com/tracy_press/mhhs-senior-makes-top-1-at-international-research-olympiad/article_4ff07e88-5a81-11ef-a874-c31e6b02f715.html', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThohJHi6ZfZb_7lw6zOxzoTCQmt2aWpN_byQ&s", description: 'MHHS senior makes top 1% at International Research Olympiad' },
  { name: 'Johnson County Post', href: 'https://johnsoncountypost.com/2025/02/01/leena-dudi-international-research-olympiad-224733//', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7rLr_amyTzBaBKuvDnL7ob2tBR3qBdPKLSg&s", description: 'This Johnson County teen is helping launch new international science contest' },
  { name: 'Wtop News', href: 'https://wtop.com/fairfax-county/2025/01/fairfax-county-teen-among-first-to-join-international-research-olympiad/', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrlZEZSQKtCFzHCCY4XRkK5BB7t9QwtzlAew&s", description: 'Fairfax County teen among first to join International Research Olympiad' },
  { name: 'Forest Grove News Times', href: 'https://www.forestgrovenewstimes.com/lifestyle/features/westview-high-grad-sets-up-competitive-international-research-contest/article_273f5d17-0beb-5a80-8bcf-0a35b0bc32e0.html', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpRbtJ1zv5KjSGRs5AwvxRw_7i20EkR-OYqg&s", description: 'Westview High grad sets up competitive international research contest' },
  { name: 'Parsippany Focus', href: 'https://parsippanyfocus.com/2025/01/31/parsippany-teen-joins-international-research-olympiad-leadership-team-to-inspire-future-scientists/', image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrVvENWgrDFBk_XwdLvEUkh36O_l-x4IN1pw&s", description: 'Parsippany Teen Joins International Research Olympiad Leadership Team to Inspire Future Scientists' },
];

function News() {
  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1 style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em"
            }}>
              IRO in the News
            </h1>
            <p style={{
              fontSize: "1.1rem",
              color: "#555",
              lineHeight: "1.7"
            }}>
              Media coverage and news articles featuring the International Research Olympiad.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        {/* Stats */}
        <div style={{
          display: "flex",
          gap: "20px",
          marginBottom: "40px",
          flexWrap: "wrap"
        }}>
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "24px 32px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
            border: "1px solid #e8eef3",
            textAlign: "center"
          }}>
            <p style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              color: "#004d99",
              margin: "0 0 4px 0",
              lineHeight: "1"
            }}>
              {newsdata.length}+
            </p>
            <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>News Features</p>
          </div>
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "24px 32px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
            border: "1px solid #e8eef3",
            textAlign: "center"
          }}>
            <p style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              color: "#004d99",
              margin: "0 0 4px 0",
              lineHeight: "1"
            }}>
              Global
            </p>
            <p style={{ fontSize: "0.9rem", color: "#666", margin: 0 }}>Media Coverage</p>
          </div>
        </div>

        {/* News Grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
          gap: "24px"
        }}>
          {newsdata.map((item, index) => (
            <a
              key={index}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                display: "block"
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 77, 153, 0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.06)';
                }}
              >
                <div style={{
                  display: "flex",
                  padding: "24px",
                  gap: "20px",
                  flex: 1
                }}>
                  {/* Logo */}
                  <div style={{
                    width: "80px",
                    height: "80px",
                    flexShrink: 0,
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        padding: "8px"
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1 }}>
                    <p style={{
                      fontSize: "0.85rem",
                      fontWeight: "600",
                      color: "#004d99",
                      marginBottom: "8px"
                    }}>
                      {item.name}
                    </p>
                    <p style={{
                      fontSize: "0.95rem",
                      color: "#1a1a2e",
                      lineHeight: "1.5",
                      marginBottom: "12px",
                      fontWeight: "500"
                    }}>
                      {item.description}
                    </p>
                    <span style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "0.85rem",
                      color: "#004d99",
                      fontWeight: "500"
                    }}>
                      Read Article <ArrowOutwardIcon style={{ fontSize: "16px" }} />
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default News;
